/*api
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { LaundryIssued,LaundryIssuedDetail } from '../../../interfaces/masters/laundryissued';
// import {LaundryIssuedDetail} from '../../interfaces/masters/laundryissueddetail';
@Injectable()
export class LaundryIssuedApi {
  private readonly apiController: string = 'laundryissued';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
   //const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  getById(url : string, options?: any): Observable<LaundryIssued> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,header);
  }

  add(url:string, data: LaundryIssued):Observable<LaundryIssued>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header);
  }

  update(url:string, data: LaundryIssued):Observable<any>{
    // let header = new HttpHeaders();
    // header.append('Content-Type', 'applications/json');
    // header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  delete(url: string):Observable<any>{
    return this.api.directDelete(url);
  }
  addDetail(url:string,data:LaundryIssuedDetail[]):Observable<any>{
    debugger;
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header);

  }
  updateDetail(url:string,data:LaundryIssuedDetail[]):Observable<any>{
    debugger;
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header);

  }
 deleteDetail(url:string):Observable<any>{
    debugger;
   return this.api.delete(url);
 }
  listDetail(url: string, options?: any):Observable<any[]>
  {
 return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
  frontList(url: string, options?: any):Observable<any[]>
  {
 return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
  
  
  quickList(url: string, options?: any):Observable<any[]>
  {
 return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
}